import React, { useContext, useRef, forwardRef, PropsWithChildren } from "react";
import { ThemeProvider, ThemeContext } from "styled-components";
import AngleDown from "core/icons/angle/angle-down.svg?react";
import AngleDownV2 from "core/icons/angle/angle-down-3.svg?react";
import {
  Container,
  ItemContainer,
  HeaderContainer,
  BodyContainer,
  AngleWrapper,
} from "./_accordionStyle";

type AccordionComponent = React.ForwardRefExoticComponent<PropsWithChildren<AccordionData>> &
  React.RefAttributes<HTMLDivElement> & {
    Item: typeof Item;
    Header: typeof Header;
    Body: typeof Body;
  };

type AccordionData = {
  variant?: "angle" | "cross" | "angle-v2";
  active?: boolean;
};

const AccordionItemContext = React.createContext<AccordionData>({});

const Accordion = forwardRef<HTMLDivElement, PropsWithChildren<AccordionData>>((props, ref) => {
  const { children, variant = "cross", ...rest } = props;
  return (
    <ThemeProvider theme={{ variant }}>
      <Container className="accordion-container" {...rest} ref={ref}>
        {children}
      </Container>
    </ThemeProvider>
  );
}) as AccordionComponent;

const Item = forwardRef<HTMLDivElement, PropsWithChildren<{ active: boolean }>>((props, ref) => {
  const { active, children, ...rest } = props;

  return (
    <AccordionItemContext.Provider value={{ active }}>
      <ThemeProvider theme={{ active }}>
        <ItemContainer className={`accordion-item ${active ? "active" : ""}`} {...rest} ref={ref}>
          {children}
        </ItemContainer>
      </ThemeProvider>
    </AccordionItemContext.Provider>
  );
});

const Header = (props: PropsWithChildren<AccordionData & { onClick?: () => void }>) => {
  const { children, ...rest } = props;
  const { active } = useContext(AccordionItemContext);
  const { variant } = useContext(ThemeContext);

  const AngleIcon = variant === "angle" ? AngleDown : AngleDownV2;

  return (
    <HeaderContainer active={active} className="accordion-header" {...rest}>
      {children}
      <AngleWrapper className="accordion-angle">
        <AngleIcon />
      </AngleWrapper>
    </HeaderContainer>
  );
};

const Body = (props: PropsWithChildren<{ direction?: "row" | "column" }>) => {
  const { children, direction, ...rest } = props;
  const { active } = useContext(AccordionItemContext);
  // const [height, setHeight] = useState(0);
  // const [isCollapsing, setIsCollapsing] = useState(false);
  // const [collapsingDuration, setCollapsingDuration] = useState(0);
  const bodyRef = useRef<HTMLDivElement>(null);
  //TODO: Add animation
  // useEffect(() => {
  //   const scrollHeight = bodyRef.current.scrollHeight;
  //   const duration = (scrollHeight / 500) * 0.35 + 0.2;
  //   if (active) {
  //     setIsCollapsing(true);
  //     setCollapsingDuration(duration);
  //     setTimeout(() => {
  //       setHeight(scrollHeight);
  //     }, 20);
  //     setTimeout(() => {
  //       setIsCollapsing(false);
  //     }, duration * 1000 - 20);
  //   } else {
  //     setIsCollapsing(true);
  //     setTimeout(() => {
  //       setHeight(0);
  //     }, 20);
  //     setTimeout(() => {
  //       setIsCollapsing(false);
  //     }, duration * 1000 - 20);
  //   }
  // }, [active]);
  return (
    <BodyContainer
      ref={bodyRef}
      className="accordion-body"
      // style={{ height: isCollapsing && `${height}px` }}
      // isCollapsing={isCollapsing}
      // collapsingDuration={collapsingDuration}
      active={active}
      direction={direction}
      {...rest}>
      {children}
    </BodyContainer>
  );
};

Accordion.displayName = "Accordion";
Accordion.Item = Item;
Accordion.Header = Header;
Accordion.Body = Body;

export default Accordion;
